import React from 'react'
import PropTypes from 'prop-types'
import ReactSelect from 'react-select'

const Select = ({
  input,
  options = [],
  label,
  styles,
  groupClassName,
  placeholder,
  inputClassName,
  labelClassName,
  errorClassName,
  handleInputChange,
  handleChange,
  disabled,
  meta: { touched, error },
  classNamePrefix = '',
  customStyles = undefined,
  defaultValue,
}) => {
  return (
    <div className={groupClassName}>
      <div className="position-relative field-wrapper input-dropdown w-full">
        {label && (
          <label className={labelClassName} htmlFor={`.${input.name}`}>
            {label}
          </label>
        )}
        <ReactSelect
          name={input.name}
          value={options.find((option) => option.value === (defaultValue || input.value)) ?? ''}
          options={options}
          className={`${inputClassName}`}
          classNamePrefix={classNamePrefix}
          styles={customStyles || styles}
          placeholder={placeholder}
          onInputChange={(value) => {
            handleInputChange && handleInputChange(value)
          }}
          onChange={({ value }) => {
            input.onChange(value)
            handleChange && handleChange(value)
          }}
          isDisabled={disabled}
          components={{ IndicatorSeparator: () => null }}
        />
        {touched && error && <p className={errorClassName}>{error}</p>}
      </div>
    </div>
  )
}

Select.propTypes = {
  input: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.object.isRequired,
  styles: PropTypes.object,
  groupClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  handleChange: PropTypes.func,
  handleInputChange: PropTypes.func,
  disabled: PropTypes.bool,
  classNamePrefix: PropTypes.string,
  customStyles: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  defaultValue: PropTypes.any,
}

export default Select
